import RemindPeopleToCheckInComponent from "./RemindPeopleToCheckInButton.component";

export default RemindPeopleToCheckInComponent;
